import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "attestButton", "status", "date", "hint"]

  attest() {
    const now = new Date().toISOString()
    this.inputTarget.value = now
    this.attestButtonTarget.classList.add("hidden")
    this.hintTarget.classList.add("hidden")
    this.statusTarget.classList.remove("hidden")
    this.dateTarget.textContent = new Date(now).toLocaleDateString()
  }

  revoke() {
    this.inputTarget.value = ""
    this.attestButtonTarget.classList.remove("hidden")
    this.hintTarget.classList.remove("hidden")
    this.statusTarget.classList.add("hidden")
  }
}
